import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";

const Navigation = () => {
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);

  const toggleSubMenu = () => {
    setIsSubMenuOpen(!isSubMenuOpen);
  };

  return (
    <nav id="main-nav">
      <div className="container">
        <a href="/">
          <img
            src="Images/pedres-flooring.png"
            alt="PedresFlooring"
            className="logo"
          />
        </a>
        <div className="links-container">
          <div className="contact-row">
            <FontAwesomeIcon icon={faPhone} className="icon" />
            <span className="text">021 198 0618</span>
            <FontAwesomeIcon icon={faEnvelope} className="icon" />
            <a href="mailto:junifer@pedresflooring.co.nz" className="text">
              junifer@pedresflooring.co.nz
            </a>
          </div>
          <ul>
            <li>
              <Link
                style={{ backgroundColor: "#187bcd", color: "#fff" }}
                to="/"
              >
                Home
              </Link>
            </li>
            <li>
              <div
                className="submenu-container"
                onMouseEnter={toggleSubMenu}
                onMouseLeave={toggleSubMenu}
              >
                <Link to="/services/supply-install">Services</Link>
                {isSubMenuOpen && (
                  <ul className="submenu">
                    <li>
                      <Link to="/services/carpet">Carpet</Link>
                    </li>
                    <li>
                      <Link to="/services/vinyl">Vinyl</Link>
                    </li>
                    <li>
                      <Link to="/services/tile">Tiles</Link>
                    </li>
                    <li>
                      <Link to="/services/timber">Timber</Link>
                    </li>
                  </ul>
                )}
              </div>
            </li>
            <li>
              <Link to="/gallery">Gallery</Link>
            </li>
            <li>
              <Link to="/about">About Us</Link>
            </li>
            {/* <li>
              <Link to="/contact">Contact</Link>
            </li> */}
            <li>
              <Link to="/quote">Get a Quote</Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
